// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ce-4";
export var closeButton = "_ce-6";
export var dismissButton = "_ce-3";
export var editImageWithAiContainer = "_ce-8";
export var imageUploadWrapper = "_ce-7";
export var misspelledWord = "_ce-5";
export var spellCheckContainer = "_ce-2";
export var spin = "_ce-1";
export var spinning = "_ce-0";